export default "__VITE_ASSET__CDc6rVAa__"